var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"copyToClipboard",staticClass:"ax-copy-to-clipboard"},[_vm._t("default",function(){return [_c('AxButton',_vm._b({on:{"click":_vm.copy}},'AxButton',_vm.buttonOptions,false),[_vm._v(" "+_vm._s(_vm.copyButtonText)+" ")])]},{"copy":_vm.copy,"delay":_vm.delay})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }